export default __webpack_public_path__ + "static/media/me-icon.ddb4910e.webp";